import { render, staticRenderFns } from "./guoqi.vue?vue&type=template&id=193b0c7a&scoped=true&"
import script from "./guoqi.vue?vue&type=script&lang=js&"
export * from "./guoqi.vue?vue&type=script&lang=js&"
import style0 from "./guoqi.vue?vue&type=style&index=0&id=193b0c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193b0c7a",
  null
  
)

export default component.exports